import React from 'react';
import config from '../../../../../../config';
import Checkbox from '../../../../../../components-new/form/Checkbox';
import TablePagination from '../../../../../../components-new/table/TablePagination';
import ContactAvatar from '../../../../../../components-new/general/ContactAvatar';
import MembersTableToolbar from './partials/MembersTableToolbar';
import MembersTableRowActions from './partials/MembersTableRowActions';
import MemberStatus from './partials/MemberStatus';
import MemberRole from './partials/MemberRole';
import MemberCustomStatus from "./partials/MemberCustomStatus";
import Input from "../../../../../../components-new/form/Input";
import Translate from "../../../../../../components/Translate";
import Colors from "../../../../../../utils/Colors";
import Tooltip from "../../../../../../components-new/general/Tooltip";
import DropdownSelect from "../../../../../../components-new/form/DropdownSelect";
import Tabs from "../../../../../../components-new/ui/Tabs";
import TableHeaderSort from "../../../../../../components-new/table/TableHeaderSort";
import TableDateTime from "../../../../../../components-new/table/TableDateTime";
import TableScroll from "../../../../../../components-new/table/TableScroll";
import './styles.css'
import EmployeePasswordModal from "../EmployeePasswordModal";
import EmployeeProfileModal from "../EmployeeProfileModal";

const tableHeaders = {
    common: [
        {key: "employee", translateKey: "employee", sortKey: "firstName"}
    ],
    mainInfo: [
        {key: "status", translateKey: "Status", align: "center", sortKey: "status"},
        {key: "currentStatus", translateKey: "currentStatus", align: "center", sortKey: "currentStatus"},
        {key: "role", translateKey: "Role", align: "center", sortKey: 'role'},
        {key: "canChangeHimselfInfo", translateKey: "canChangeHimselfInfo", align: "center"}
    ],
    other: [
        {key: "language", translateKey: "language", align: "center"},
        {key: "chatLimit", translateKey: "chatLimit", align: "center"},
        {key: "currentChatLimit", translateKey: "currentChatLimit", align: "center"}
    ],
    dateAndActions: [
        {key: "createdAt", translateKey: "createdAt", sortKey: "createdAt", align: "center"},
        {key: 'actions', translateKey: "", align: "center"},
    ]
};

class EmployeesTable extends React.Component {
    state = {
        activeTab: 'mainInfo',
        passwordMember: null,
        profileMember: null,
    };

    setActiveTab = (tab) => {
        this.setState({activeTab: tab});
    };

    render() {
        const {
            numSelected,
            selectedMembers,
            searchString,
            handleSearch,
            handleRemoveMembers,
            handleSelectAllClick,
            user,
            columnData,
            order,
            orderBy,
            setOrder,
            filteredMembers,
            pageData,
            chatLimit,
            currentChatLimit,
            rowsPerPage,
            page,
            iconMap
        } = this.props;

        const {activeTab, passwordMember, profileMember} = this.state;

        return (
            /*
             * A column that fills what it is given: the toolbar and the tabs keep
             * their height and the table takes the rest. It used to be a plain
             * block with the table pinned to 50vh, so on a tall screen the page
             * ended halfway down and on a short one it scrolled twice.
             */
            <div style={{display: 'flex', flexDirection: 'column', minHeight: 0, flex: 1}}>


                <MembersTableToolbar
                    numSelected={numSelected}
                    searchString={searchString}
                    handleSearch={handleSearch}
                    removeMembers={() => handleRemoveMembers(selectedMembers)}
                    user={user}
                />

                <div style={{marginBottom: '16px'}}>
                    <Tabs
                        selectedTab={activeTab}
                        onTabChange={this.setActiveTab}
                        tabs={['mainInfo', 'other']}
                        variant="underline"
                    />
                </div>

                {/*
                  * Takes the height the toolbar, the tabs and the pagination
                  * leave - exactly what .history-table-scroll does on the
                  * history page. minHeight on its own permits shrinking but
                  * asks for nothing, so the table kept growing to fit its rows.
                  *
                  * The pagination below needs no guard of its own: .table-
                  * pagination already carries flex-shrink: 0.
                  */}
                <TableScroll style={{flex: '1 1 auto', minHeight: 0}} stickyActions>
                    <table className={`custom-table employees-table employees-table--${activeTab}`}>
                        <thead className="thead1">
                        <tr>
                            <th>
                                <Checkbox
                                    checked={pageData.filter(item => item.role !== config.rolesMap.owner).every(item => selectedMembers.some(s => s.id === item.id))}
                                    handleChange={handleSelectAllClick}
                                    size={16}
                                />
                            </th>
                            {[
                                ...tableHeaders.common,
                                ...(activeTab === "mainInfo" ? tableHeaders.mainInfo : tableHeaders.other),
                                ...tableHeaders.dateAndActions,
                            ].map((header) => {
                                return (
                                    <th
                                        style={{textAlign: header.align, whiteSpace: 'nowrap'}}
                                        key={header.key}
                                        onClick={() => {
                                            if (!header.sortKey) return
                                            setOrder(header.sortKey, order === 'asc' ? 'desc' : 'asc');
                                        }}
                                    >
                                        {
                                            header.sortKey ? (
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    gap: '6px'
                                                }}>
                                                    <Translate text={header.translateKey}/>
                                                    <TableHeaderSort isActive={orderBy === header.sortKey}
                                                                     direction={order}/>
                                                </div>
                                            ) : (
                                                <Translate text={header.translateKey}/>
                                            )
                                        }
                                    </th>
                                )
                            })}

                        </tr>
                        </thead>
                        <tbody>
                        {pageData.map((n) => {
                            const isRowSelected = this.props.isSelected(n.id);

                            return (
                                <tr
                                    className="tr-body1"
                                    key={n.id}
                                    style={{
                                        opacity: n.role === config.rolesMap.owner ? '0.5' : '1',
                                        pointerEvents: n.role === config.rolesMap.owner ? 'none' : 'all',
                                    }}
                                >
                                    <td style={{width: '30px', textAlign: 'center'}}>
                                        <Checkbox
                                            handleChange={this.props.handleMemberSelectChange(n.id)}
                                            checked={isRowSelected}
                                            size="16"
                                        />
                                    </td>

                                    <td>
                                        <div style={{display: 'flex', height: '60px', alignItems: 'center'}}>

                                            <div style={{flexShrink: '0', display: 'flex', alignItems: 'center'}}>
                                                <ContactAvatar contact={n} variant="chatMenu" size={40}/>
                                            </div>

                                            <div className="employee-cell-info">
                                                <div className="employee-cell-name">
                                                    {[n.firstName, n.lastName].filter(Boolean).join(' ') || '—'}
                                                </div>
                                                {/* One line, cut with an ellipsis. A long
                                                    address used to wrap and push the row past
                                                    its height, over the employee below it.
                                                    The whole of it is in the tooltip - ours,
                                                    and told not to translate it: an address is
                                                    not a phrase. minWidth on the wrapper is
                                                    what lets the span shrink far enough to
                                                    reach its own ellipsis. */}
                                                <Tooltip
                                                    text={n.email + ' / ' + n.username}
                                                    needTranslate={false}
                                                    style={{minWidth: 0}}
                                                >
                                                    <span
                                                        style={{
                                                            display: 'block',
                                                            fontSize: '12px',
                                                            color: 'var(--ds-text-tertiary)',
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                        }}>{n.email} / {n.username}</span>
                                                </Tooltip>
                                            </div>
                                        </div>
                                    </td>


                                    {activeTab === 'mainInfo' && (
                                        <React.Fragment>
                                            <td style={{textAlign: 'center',}}>
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    height: '60px'
                                                }}>
                                                    <MemberStatus
                                                        member={n}
                                                        updateStatus={this.props.handleMemberStatusChange(n)}
                                                    />
                                                </div>
                                            </td>
                                            <td style={{textAlign: 'center'}}>
                                                {n.platformId && (
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        height: '60px'
                                                    }}>
                                                        <MemberCustomStatus
                                                            member={n}
                                                            updateCurrentStatus={this.props.handleMemberCurrentStatusChange(n)}
                                                        />
                                                    </div>
                                                )}
                                            </td>
                                            <td style={{textAlign: 'center'}}>
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    height: '60px'
                                                }}>
                                                    <MemberRole member={n}
                                                                updateRole={this.props.handleMemberRoleChange(n)}/>
                                                </div>
                                            </td>
                                            <td style={{textAlign: 'center'}}>
                                                <div className="custom-align-div">
                                                    <Tooltip inRightSide={true} text={'operatorCanChangeHimselfInfo'}>
                                                        <Checkbox
                                                            handleChange={(v) => {
                                                                this.props.handleMemberCCHI(n)(v)
                                                            }}
                                                            checked={n.canChangeHimselfInfo}
                                                            size={16}
                                                        />
                                                    </Tooltip>
                                                </div>
                                            </td>
                                        </React.Fragment>
                                    )}

                                    {activeTab === 'other' && (
                                        <React.Fragment>
                                            <td style={{textAlign: 'center'}}>
                                                {n.platformId && (
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        height: '60px'
                                                    }}>
                                                        <DropdownSelect
                                                            /* fixed rather than absolute: a menu
                                                               in the table's own flow stretched
                                                               the page when it opened on the
                                                               last row */
                                                            overlay
                                                            options={config.locales2}
                                                            selectedValue={config.locales2.find(locale => locale.id === n.language)}
                                                            onChange={(val) => this.props.handleOperatorInfoChange(n.id, 'language', val.value)}
                                                            variant='outline'
                                                            renderLabel={
                                                                (val) => {
                                                                    return (
                                                                        <div style={{
                                                                            display: 'flex',
                                                                            gap: '10px',
                                                                            alignItems: 'center'
                                                                        }}>
                                                                            {iconMap[val.title]}
                                                                            <span>{val.title.toUpperCase()}</span>
                                                                        </div>
                                                                    )
                                                                }
                                                            }
                                                            styles={{color: 'var(--ds-text-primary)', width: '100px'}}
                                                        >
                                                            {(option) =>
                                                                <div style={{
                                                                    display: 'flex',
                                                                    gap: '10px',
                                                                    alignItems: 'center'
                                                                }}>
                                                                    {iconMap[option.value]}
                                                                    <span>{option.title}</span>
                                                                </div>
                                                            }
                                                        </DropdownSelect>
                                                    </div>
                                                )}
                                            </td>
                                            <td style={{textAlign: 'center'}}>
                                                {n.platformId && (
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        height: '60px'
                                                    }}>
                                                        <Input
                                                            type="number"
                                                            value={chatLimit[n.platformId] || n.chatLimit}
                                                            onChange={this.props.handleChatLimitChange(n.platformId)}
                                                            onBlur={this.props.handleChatLimitBlur(n.platformId)}
                                                        />
                                                    </div>
                                                )}
                                            </td>
                                            <td style={{textAlign: 'center'}}>
                                                {n.platformId && (
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        height: '60px'
                                                    }}>
                                                        <Input
                                                            type="number"
                                                            value={currentChatLimit[n.platformId] || n.currentChatLimit}
                                                            onChange={this.props.handleCurrentChatLimitChange(n.platformId)}
                                                            onBlur={this.props.handleCurrentChatLimitBlur(n.platformId)}
                                                        />
                                                    </div>
                                                )}
                                            </td>
                                        </React.Fragment>
                                    )}

                                    <td style={{textAlign: 'center'}}>
                                        <div className="custom-align-div">
                                            <TableDateTime value={n.createdAt}/>
                                        </div>
                                    </td>

                                    <td>
                                        <div className="custom-align-div">
                                            <MembersTableRowActions
                                                member={n}
                                                removeMember={() => this.props.handleRemoveMembers([n])}
                                                reInviteMember={this.props.reInviteMember}
                                                changePassword={(member) => this.setState({passwordMember: member})}
                                                editProfile={(member) => this.setState({profileMember: member})}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                        {pageData.length === 0 && (
                            <tr className="table-no-result">
                                <td
                                    colSpan={8}
                                    style={{
                                        height: '160px',
                                        textAlign: 'center',
                                        color: Colors.silverWhiteSemiDark,
                                    }}
                                >
                                    <Translate text="noEmployeesYet"/>
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>

                </TableScroll>

                <TablePagination
                    totalRows={filteredMembers.length}
                    numberOfPages={Math.ceil(filteredMembers.length / rowsPerPage)}
                    handleChangeRowsPerPage={this.props.handleChangeRowsPerPage}
                    rowsPerPage={rowsPerPage}
                    curPage={page}
                    selectPage={this.props.handleChangePage}
                />

                <EmployeePasswordModal
                    member={passwordMember}
                    onClose={() => this.setState({passwordMember: null})}
                />

                <EmployeeProfileModal
                    member={profileMember}
                    onClose={() => this.setState({profileMember: null})}
                    onSave={this.props.handleOperatorProfileChange}
                />
            </div>
        );
    }
}

export default EmployeesTable;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/members/EmployeesTable/index.jsx